(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["medal-live-preview"] && !Shopify.designMode) return;
  try {
    class MedalLivePreview extends HTMLElement {
    connectedCallback() {
      this.previewText = this.querySelector('[data-preview-text]');
      this.characterCount = this.querySelector('[data-character-count]');
      this.iconInputs = [...this.querySelectorAll('[data-medal-icon]')];
      this.fontInputs = [...this.querySelectorAll('[data-medal-font]')];
      this.productScope = this.closest('.shopify-section') || document;
      this.textInput = this.productScope.querySelector('product-personalization input[name^="properties["][type="text"]');
      this.variantPicker = this.productScope.querySelector('variant-picker');
      this.originalMaxLength = this.textInput?.getAttribute('maxlength') || '';

      this.handleText = () => this.renderText();
      this.handleIcon = () => this.renderSelectedIcon();
      this.handleFont = () => this.renderSelectedFont();
      this.handleVariant = () => this.renderVariantState();

      this.textInput?.addEventListener('input', this.handleText, { passive: true });
      this.variantPicker?.addEventListener('change', this.handleVariant);
      this.iconInputs.forEach((input) => input.addEventListener('change', this.handleIcon));
      this.fontInputs.forEach((input) => input.addEventListener('change', this.handleFont));
      this.renderVariantState();
      this.renderText();
      this.renderSelectedIcon();
      this.renderSelectedFont();
    }

    disconnectedCallback() {
      this.textInput?.removeEventListener('input', this.handleText);
      this.variantPicker?.removeEventListener('change', this.handleVariant);
      this.iconInputs.forEach((input) => input.removeEventListener('change', this.handleIcon));
      this.fontInputs.forEach((input) => input.removeEventListener('change', this.handleFont));
    }

    renderVariantState() {
      const selectedValues = this.variantPicker
        ? [
            ...this.variantPicker.querySelectorAll('input[type="radio"]:checked'),
            ...this.variantPicker.querySelectorAll('select option:checked')
          ].map((input) => input.value || input.textContent || '').join(' ')
        : this.dataset.blackVariant;
      const blackVariant = selectedValues
        .toLocaleLowerCase('fr')
        .includes(this.dataset.blackVariant.toLocaleLowerCase('fr'));

      this.hidden = !blackVariant;
      [...this.iconInputs, ...this.fontInputs].forEach((input) => {
        input.disabled = !blackVariant;
      });

      if (this.textInput) {
        if (blackVariant) {
          this.textInput.maxLength = 14;
          if ([...this.textInput.value].length > 14) {
            this.textInput.value = [...this.textInput.value].slice(0, 14).join('');
            this.textInput.dispatchEvent(new Event('input', { bubbles: true }));
          }
        } else if (this.originalMaxLength) {
          this.textInput.setAttribute('maxlength', this.originalMaxLength);
        } else {
          this.textInput.removeAttribute('maxlength');
        }
      }
    }

    renderText() {
      const rawValue = this.textInput?.value || '';
      const value = rawValue.trim() || 'Milou';
      this.previewText.textContent = value;
      this.characterCount.textContent = [...rawValue].length;
      this.querySelector('[data-example-note]')?.toggleAttribute('hidden', Boolean(rawValue.trim()));
      requestAnimationFrame(() => this.fitText());
    }

    fitText() {
      const referenceSize = 60;
      const targetWidth = 248;
      this.previewText.style.fontSize = `${referenceSize}px`;
      this.previewText.removeAttribute('textLength');
      this.previewText.removeAttribute('lengthAdjust');
      const measuredWidth = this.previewText.getComputedTextLength();
      if (measuredWidth > 0) {
        const fittedSize = Math.min(76, Math.max(16, referenceSize * targetWidth / measuredWidth));
        this.previewText.style.fontSize = `${fittedSize}px`;
        if (this.previewText.getComputedTextLength() > 252) {
          this.previewText.setAttribute('textLength', '252');
          this.previewText.setAttribute('lengthAdjust', 'spacingAndGlyphs');
        }
      }
    }

    renderSelectedIcon() {
      const selected = this.iconInputs.find((input) => input.checked)?.dataset.medalIcon || 'paw';
      this.querySelectorAll('[data-preview-icon]').forEach((icon) => {
        const visible = selected !== 'none' && icon.dataset.previewIcon === selected;
        icon.toggleAttribute('hidden', !visible);
        icon.style.display = visible ? '' : 'none';
      });
    }

    renderSelectedFont() {
      const selected = this.fontInputs.find((input) => input.checked)?.dataset.medalFont || 'Arial';
      const safeFonts = {
        'Arial': 'Arial, Helvetica, sans-serif',
        'Georgia': 'Georgia, Times, serif',
        'Segoe Script': '"Segoe Script", "Brush Script MT", "Apple Chancery", cursive',
        'Comic Sans MS': '"Comic Sans MS", "Chalkboard SE", "Comic Sans", cursive'
      };
      this.previewText.style.fontFamily = safeFonts[selected] || safeFonts.Arial;
      requestAnimationFrame(() => this.fitText());
    }
  }

  if (!customElements.get('medal-live-preview')) {
    customElements.define('medal-live-preview', MedalLivePreview);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["medal-personalizer-link"] && !Shopify.designMode) return;
  try {
    class MedalPersonalizerLink extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('[data-personalizer-link]');
      this.scope = this.closest('.shopify-section') || document;
      this.variants = JSON.parse(this.querySelector('[data-medal-variants]')?.textContent || '[]');
      this.selectedOptions = JSON.parse(this.querySelector('[data-selected-options]')?.textContent || '[]');
      this.handleChange = (event) => this.updateVariant(event);
      this.scope.addEventListener('change', this.handleChange);
    }
    disconnectedCallback() { this.scope?.removeEventListener('change', this.handleChange); }
    updateVariant(event) {
      const control = event.target.closest('variant-picker input, variant-picker select');
      if (!control) return;
      const selected = control.matches('select') ? control.selectedOptions[0] : control;
      const position = Number((selected?.dataset.inputId || '').split('-')[0]) - 1;
      if (position >= 0) this.selectedOptions[position] = selected.value;
      const variant = this.variants.find((candidate) =>
        candidate.options.every((value, index) => value === this.selectedOptions[index])
      );
      if (!variant || !this.link) return;
      this.link.dataset.variantId = String(variant.id);
      this.link.href = `${this.dataset.productUrl}?view=personnalisation-medaille&variant=${variant.id}`;
    }
  }
  if (!customElements.get('medal-personalizer-link')) {
    customElements.define('medal-personalizer-link', MedalPersonalizerLink);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["medals-buy-buttons"] && !Shopify.designMode) return;
  try {
    class MedalsBuyButtons extends HTMLElement {
    audioContext = null;
    fileSubmissionInProgress = false;

    connectedCallback() {
      this.addEventListener('click', this.handleFileClick, true);
      this.addEventListener('click', this.handleQuantity);
      this.addEventListener('submit', this.handleFileSubmit, true);
      this.addEventListener('shopify:cart:lines-update', this.handleCartLinesUpdate);
      this.normalizeBackorderOptions();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleFileClick, true);
      this.removeEventListener('click', this.handleQuantity);
      this.removeEventListener('submit', this.handleFileSubmit, true);
      this.removeEventListener('shopify:cart:lines-update', this.handleCartLinesUpdate);
      this.audioContext?.close();
      this.audioContext = null;
    }

    normalizeBackorderOptions() {
      if (this.dataset.allVariantsContinue !== 'true') return;

      const section = this.closest('.shopify-section');
      section?.querySelectorAll('variant-picker input[data-option-available]').forEach((input) => {
        input.dataset.optionAvailable = 'true';
        input.removeAttribute('aria-disabled');
        input.setAttribute('aria-label', input.value);

        const label = input.closest('.variant-option__button-label');
        const text = label?.querySelector('[data-key="variant-option-text"]');
        if (label && text && !label.querySelector('[data-key="variant-option-pill"]')) {
          const pill = document.createElement('span');
          pill.className = 'variant-option__button-label__pill';
          pill.dataset.key = 'variant-option-pill';
          label.insertBefore(pill, text);
        }
      });
    }

    handleQuantity = (event) => {
      const button = event.target.closest('[data-quantity-decrease], [data-quantity-increase]');
      if (!button || !this.contains(button)) return;

      const wrapper = button.closest('.medals-buy-buttons__quantity');
      const input = wrapper?.querySelector('.medals-buy-buttons__quantity-input');
      if (!input) return;

      const step = Number(input.step) || 1;
      const minimum = Number(input.min) || 1;
      const maximum = Number(input.max) || 10;
      const direction = button.hasAttribute('data-quantity-increase') ? 1 : -1;
      const nextValue = (Number(input.value) || minimum) + direction * step;
      input.value = String(Math.min(maximum, Math.max(minimum, nextValue)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };


    hasSelectedFile(form) {
      return Array.from(form.elements).some(
        (element) => element instanceof HTMLInputElement && element.type === 'file' && element.files?.length
      );
    }

    hasSelectedSpreadsheet(form) {
      return Array.from(form.elements).some((element) => {
        if (!(element instanceof HTMLInputElement) || element.type !== 'file' || !element.files?.length) {
          return false;
        }

        return Array.from(element.files).some((file) => /\.(csv|xls|xlsx)$/i.test(file.name));
      });
    }

    handleFileClick = (event) => {
      const submitButton = event.target.closest('button[type="submit"], input[type="submit"]');
      if (!submitButton || !this.contains(submitButton)) return;

      const form = submitButton.form;
      if (!(form instanceof HTMLFormElement) || !this.hasSelectedFile(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      this.startFileSubmission(form);
    };

    handleFileSubmit = (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !this.contains(form) || !this.hasSelectedFile(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      this.startFileSubmission(form);
    };

    startFileSubmission(form) {
      if (this.fileSubmissionInProgress) return;

      if (this.hasSelectedSpreadsheet(form)) {
        this.submitSpreadsheetNatively(form);
        return;
      }

      this.fileSubmissionInProgress = true;
      this.submitFormWithFile(form).finally(() => {
        this.fileSubmissionInProgress = false;
      });
    }

    submitSpreadsheetNatively(form) {
      const section = this.closest('.shopify-section');
      section?.querySelectorAll('product-personalization').forEach((component) => {
        component.updatePanels?.();
      });

      if (!form.reportValidity()) return;

      this.fileSubmissionInProgress = true;
      form.method = 'post';
      form.enctype = 'multipart/form-data';
      HTMLFormElement.prototype.submit.call(form);
    }

    async submitFormWithFile(form) {
      const submitButton = form.querySelector('[type="submit"]');
      const productForm = this.querySelector('product-form-component');
      const variantId = String(new FormData(form).get('id') || '');
      const quantity = Number(new FormData(form).get('quantity')) || 1;
      const eventPromise = this.createDeferredPromise();
      const cartEvent = new Event('shopify:cart:lines-update', { bubbles: true, composed: true });

      Object.defineProperties(cartEvent, {
        action: { value: 'add' },
        context: { value: 'product' },
        lines: { value: [{ merchandiseId: variantId, quantity }] },
        promise: { value: eventPromise.promise },
      });

      (productForm || this).dispatchEvent(cartEvent);
      if (submitButton instanceof HTMLButtonElement) submitButton.disabled = true;

      try {
        const formData = new FormData(form);
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((component) => component instanceof HTMLElement ? component.dataset.sectionId : '')
          .filter(Boolean);
        if (sectionIds.length) formData.set('sections', [...new Set(sectionIds)].join(','));

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
          credentials: 'same-origin',
        });
        const addedItem = await response.json();
        if (!response.ok || addedItem.status) {
          throw new Error(addedItem.description || addedItem.message || 'Ajout au panier impossible');
        }

        const cartResponse = await fetch('/cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });
        if (!cartResponse.ok) throw new Error('Actualisation du panier impossible');
        const cart = await cartResponse.json();

        eventPromise.resolve({
          cart: {
            ...cart,
            itemCount: cart.item_count,
            totalQuantity: cart.item_count,
          },
          detail: {
            items: cart.items,
            source: 'product-form-component',
            sourceId: productForm?.id || '',
            itemCount: quantity,
            productId: productForm?.dataset.productId,
            sections: addedItem.sections,
            didError: false,
          },
        });

        const cartItemsComponent = document.querySelector('cart-items-component');
        if (cartItemsComponent) {
          customElements.whenDefined('cart-items-component')
            .then(() => cartItemsComponent.fetchCartData?.())
            .catch(() => {});
        }

      } catch (error) {
        eventPromise.reject(error);
        const liveRegion = productForm?.querySelector('[ref="liveRegion"]');
        if (liveRegion) liveRegion.textContent = error instanceof Error ? error.message : 'Ajout au panier impossible';
      } finally {
        if (submitButton instanceof HTMLButtonElement) submitButton.disabled = false;
      }
    }

    createDeferredPromise() {
      let resolve;
      let reject;
      const promise = new Promise((promiseResolve, promiseReject) => {
        resolve = promiseResolve;
        reject = promiseReject;
      });
      return { promise, resolve, reject };
    }
    handleCartLinesUpdate = (event) => {
      if (event.action !== 'add' || !(event.promise instanceof Promise)) return;

      const audioContext = this.prepareAudioContext();
      if (!audioContext) return;

      event.promise
        .then(({ detail }) => {
          if (detail?.didError || detail?.source !== 'product-form-component') return;
          this.playCartClick(audioContext);
        })
        .catch(() => {});
    };

    prepareAudioContext() {
      const AudioContextClass = window.AudioContext || window.webkitAudioContext;
      if (!AudioContextClass) return null;

      this.audioContext ??= new AudioContextClass();
      if (this.audioContext.state === 'suspended') {
        this.audioContext.resume().catch(() => {});
      }
      return this.audioContext;
    }

    playCartClick(audioContext) {
      if (audioContext.state !== 'running') return;

      const startedAt = audioContext.currentTime;
      const oscillator = audioContext.createOscillator();
      const gain = audioContext.createGain();

      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(960, startedAt);
      oscillator.frequency.exponentialRampToValueAtTime(720, startedAt + 0.055);
      gain.gain.setValueAtTime(0.0001, startedAt);
      gain.gain.exponentialRampToValueAtTime(0.028, startedAt + 0.006);
      gain.gain.exponentialRampToValueAtTime(0.0001, startedAt + 0.055);

      oscillator.connect(gain);
      gain.connect(audioContext.destination);
      oscillator.start(startedAt);
      oscillator.stop(startedAt + 0.06);
    }
  }

  if (!customElements.get('medals-buy-buttons')) {
    customElements.define('medals-buy-buttons', MedalsBuyButtons);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-personalization"] && !Shopify.designMode) return;
  try {
    class ProductPersonalization extends HTMLElement {
    connectedCallback() {
      this.choices = Array.from(this.querySelectorAll('[data-personalization-choice]'));
      this.panels = Array.from(this.querySelectorAll('[data-personalization-panel]'));
      this.files = Array.from(this.querySelectorAll('input[type="file"]'));
      this.fileClearButtons = Array.from(this.querySelectorAll('[data-file-clear]'));
      this.resetButton = this.querySelector('[data-personalization-reset]');
      this.section = this.closest('.shopify-section');
      this.choices.forEach((choice) => choice.addEventListener('change', this.handleChoice));
      this.files.forEach((file) => file.addEventListener('change', this.handleFile));
      this.fileClearButtons.forEach((button) => button.addEventListener('click', this.handleFileClear));
      this.resetButton?.addEventListener('click', this.handleReset);
      this.section?.addEventListener('change', this.handleVariantChange);
      document.addEventListener('shopify:cart:lines-update', this.handleCartLinesUpdate);
      this.updatePanels();
    }

    disconnectedCallback() {
      this.choices?.forEach((choice) => choice.removeEventListener('change', this.handleChoice));
      this.files?.forEach((file) => file.removeEventListener('change', this.handleFile));
      this.fileClearButtons?.forEach((button) => button.removeEventListener('click', this.handleFileClear));
      this.resetButton?.removeEventListener('click', this.handleReset);
      this.section?.removeEventListener('change', this.handleVariantChange);
      document.removeEventListener('shopify:cart:lines-update', this.handleCartLinesUpdate);
    }

    handleChoice = () => {
      this.updatePanels();
    };

    handleVariantChange = (event) => {
      if (!event.target.matches('variant-picker input[data-option-name], variant-picker select')) return;
      this.updateEngravingFields();
    };

    handleFile = (event) => {
      const input = event.currentTarget;
      const limit = Number(input.dataset.fileSizeLimit || 0);
      const file = input.files?.[0];
      input.setCustomValidity('');
      if (file && limit && file.size > limit) {
        this.clearFile(input);
        input.setCustomValidity(this.dataset.fileSizeMessage || '');
        input.reportValidity();
      }
      this.updateFilePicker(input);
    };

    handleFileClear = (event) => {
      const picker = event.currentTarget.closest('.product-personalization__file-picker');
      const input = picker?.querySelector('input[type="file"]');
      if (!input) return;
      this.clearFile(input);
    };

    handleReset = () => {
      this.resetPersonalization({ focusResetButton: true });
    };

    handleCartLinesUpdate = (event) => {
      if (
        event.action !== 'add' ||
        !event.promise ||
        typeof event.promise.then !== 'function'
      ) return;

      event.promise
        .then(({ detail } = {}) => {
          if (
            detail?.didError ||
            detail?.source !== 'product-form-component'
          ) return;

          const productMatches =
            detail?.productId &&
            String(detail.productId) === String(this.dataset.productId);

          const formMatches =
            detail?.sourceId &&
            detail.sourceId === this.dataset.productFormId;

          if (!productMatches && !formMatches) return;

          this.resetPersonalization({ focusResetButton: false });
        })
        .catch(() => {});
    };

    resetPersonalization({ focusResetButton = false } = {}) {
      const sameChoice = this.querySelector(
        '[data-personalization-choice="same"]'
      );
      if (sameChoice) sameChoice.checked = true;

      this.querySelectorAll(
        'input[type="text"], textarea'
      ).forEach((control) => {
        control.value = '';
        control.setCustomValidity('');
      });

      this.querySelectorAll(
        'input[type="checkbox"]'
      ).forEach((control) => {
        control.checked = false;
        control.setCustomValidity('');
      });

      this.files.forEach((input) => this.clearFile(input));
      this.updatePanels();

      if (focusResetButton) this.resetButton?.focus();
    }

    clearFile(input) {
      input.value = '';
      input.setCustomValidity('');
      this.updateFilePicker(input);
    }

    updateFilePicker(input) {
      const picker = input.closest('.product-personalization__file-picker');
      const fileName = picker?.querySelector('[data-file-name]');
      const clearButton = picker?.querySelector('[data-file-clear]');
      const selectedFile = input.files?.[0];
      if (fileName) fileName.textContent = selectedFile?.name || this.dataset.noFileLabel;
      if (clearButton) clearButton.hidden = !selectedFile;
    }

    updatePanels() {
      const selected = this.querySelector('[data-personalization-choice]:checked')?.dataset.personalizationChoice;
      this.panels.forEach((panel) => {
        const active = panel.dataset.personalizationPanel === selected;
        panel.hidden = !active;
        panel.querySelectorAll('[data-personalization-control]').forEach((control) => {
          control.disabled = !active;
          control.required = active && control.hasAttribute('data-required-when-active');
        });
      });
      this.updateEngravingFields();
    }

    updateEngravingFields() {
      const selectedInputs = Array.from(
        this.section?.querySelectorAll("variant-picker input[data-option-name]:checked") || []
      );
      const selectedOptions = Array.from(
        this.section?.querySelectorAll("variant-picker select option:checked") || []
      );

      const option = [...selectedInputs, ...selectedOptions].find((control) =>
        control.dataset.optionName?.trim().toLocaleLowerCase("fr") === "gravure"
      );
      const value = option?.value?.trim().toLocaleLowerCase("fr") || "";
      const alwaysShowOptionalBack =
        this.dataset.alwaysShowOptionalBack === "true";
      const verso = alwaysShowOptionalBack || value.includes("verso");
      const qr = this.dataset.enableQrField === "true" && value.includes("qr");
      const same =
        this.querySelector("[data-personalization-choice]:checked")
          ?.dataset.personalizationChoice === "same";
      const backField = this.querySelector("[data-personalization-back-field]");
      const backInput = backField?.querySelector("[data-required-when-recto-verso]");
      const qrField = this.querySelector("[data-personalization-qr-field]");
      const qrInput = qrField?.querySelector("[data-required-when-qr]");
      const help = this.querySelector("[data-personalization-spreadsheet-help]");

      if (backField) backField.hidden = !verso;
      if (backInput) {
        backInput.disabled = !same || !verso;
        backInput.required =
          same && verso && !qr && !alwaysShowOptionalBack;
        if (!verso) backInput.value = "";
      }
      if (qrField) qrField.hidden = !qr;
      if (qrInput) {
        qrInput.disabled = !same || !qr;
        qrInput.required = same && qr;
        if (!qr) qrInput.value = "";
      }
      if (help) {
        help.textContent = qr
          ? help.dataset.rectoVersoQrHelp
          : verso
            ? help.dataset.rectoVersoHelp
            : help.dataset.rectoHelp;
      }
    }
  }

  if (!customElements.get('product-personalization')) {
    customElements.define('product-personalization', ProductPersonalization);
  }
  } catch(e) { console.error(e); }
})();

})();
